angular.module('dpw.directives').directive('manageRoleAndAppAccess', [function () {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'manage-role-and-app-access.html',
        controllerAs: 'ctrl',
        controller: ['$scope', 'dpwUserRoleService', 'dpwAppAccessService', 'applicationService', 'manageRoleAndAppAccessService', 'dpwRoutes', 'popupUtil', function ($scope, dpwUserRoleService, dpwAppAccessService, applicationService, manageRoleAndAppAccessService, dpwRoutes, popupUtil) {
            var self = this;
            self.userRoles = dpwUserRoleService.getConfig();
            self.appAccessConfig = dpwAppAccessService.getConfig();

            self.featureConfig = _.assign({
                showHeader: false,
                extraClass: '',
                onChange: angular.noop,
                onSubmit: angular.noop,
                onClose: angular.noop,
                shouldDisplayErrorIfAny: false
            }, $scope.rolePermissionConfig);

            self.model = {
                userRole: '',
                appAccessSettings: {}
            };

            self.store = {
                applications: [],
                originalAppAccessSettings: {}
            };

            self.$onInit = function () {
                loadApps();
                onChange();

                if (isForExistingUser()) {
                    loadRolePermission();
                }
            };

            self.shouldDisplayAppAccessSettings = function () {
                return manageRoleAndAppAccessService.shouldDisplayAppAccessSettings(self.model.userRole);
            };

            self.getAppUrl = function (application) {
                var path = dpwRoutes.appDashboard.path.replace(':id', application.id);
                return [RCDPW.entries.console.href, path].join('#');
            };

            self.showSubmitBtn = function () {
                return self.featureConfig.onSubmit !== angular.noop;
            };

            self.shouldDisplayErrorIfAny = function () {
                return !!$scope.rolePermissionConfig.shouldDisplayErrorIfAny;
            };

            self.close = function () {
                self.featureConfig.onClose();
            };

            self.submit = function () {
                self.featureConfig.onSubmit({
                    developerId: self.featureConfig.developerId,
                    userRole: self.model.userRole,
                    appAccessSettings: self.model.appAccessSettings,
                    originalAppAccessSettings: self.store.originalAppAccessSettings
                });
            };

            self.errorMessages = {
                ROLE_NOT_SPECIFIED: RCDPW.Lang.MyAccount.RolePermission.ERROR_ROLE_NOT_SPECIFIED
            };

            function loadApps() {
                applicationService.fetchApps({perPage: 1000})
                    .then(function (applications) {
                        self.store.applications = applications;
                        initAppAccessSettings(applications);
                    });
            }

            function isForExistingUser() {
                return !!self.featureConfig.developerId;
            }

            function loadRolePermission() {
                manageRoleAndAppAccessService.fetchRolePermission(self.featureConfig.developerId).then(function (data) {
                    self.model.userRole = data.userRole;
                    _.assign(self.model.appAccessSettings, data.appAccessSettings);
                    _.assign(self.store.originalAppAccessSettings, data.appAccessSettings);
                });
            }

            function onChange() {
                $scope.$watch('ctrl.model', function () {
                    self.featureConfig.onChange({
                        userRoleId: self.model.userRole,
                        appAccessSettings: self.model.appAccessSettings
                    });
                }, true);
            }

            function initAppAccessSettings(applications) {
                applications.forEach(function (app) {
                    var appAccess = self.model.appAccessSettings[app.id];
                    if (appAccess !== dpwAppAccessService.AppAccess.ReadWrite) {
                        self.model.appAccessSettings[app.id] = dpwAppAccessService.AppAccess.ReadOnly;
                    }
                });
            }
        }]
    };
}]);
